import moment from 'jalali-moment';
import { useCallback, useState } from 'react';
import { ReserveHttp } from '@/services';
import { mapItems } from '@/services/mappers/program';
import parseError from '@/utils/parseError';

export default function usePrograms() {

  const [fetchError, setFetchError] = useState();
  const [isProgramsFetching, setFetching] = useState(true);
  const [programs, setPrograms] = useState<SelfMealEntity[]>([]);
  const [groupedPrograms, setGroupedPrograms] = useState<Dictionary<SelfMealEntity[]>>({});

  const fetchPrograms = useCallback(async (selfId: number, date?: string) => {
    if (!selfId) return;
    if (!date) {
      date = moment().locale('en').format('YYYY-MM-DD');
    }
    setFetching(true);
    try {
      setPrograms([]);
      const response = await ReserveHttp.fetchSelfProgram({
        selectedSelfId: selfId,
        showingDate: `${date}+00:00:00`
      });
      const { programs, groupedPrograms } = mapItems(response.data.payload, date);
      setPrograms(programs);
      setGroupedPrograms(groupedPrograms);
    }
    catch (e) {
      setPrograms([]);
      setGroupedPrograms({});
      setFetchError(parseError(e));
    }
    finally {
      setFetching(false);
    }
  }, []);

  return { programs, groupedPrograms, fetchError, fetchPrograms, isProgramsFetching };

}
